import { useApiClient } from '../../hooks/useApiClient.ts';
import { TeamType } from '../../types/Team/TeamType.type.ts';

export const useTeamTypeApi = () => {
  const apiClient = useApiClient();

  return {
    getTeamTypes: (): Promise<TeamType[]> => apiClient(`/team_types/`),
  };
};
